export const TYPE_SELECT = 'select'
export const TYPE_ARRAY = 'array'
export const TYPE_FORMULA = 'formula'
export const TYPE_INPUT_NUMBER = 'number'
export const TYPE_INPUT_TEXT = 'string'
export const TYPE_INPUT_FILE = 'file'
export const TYPE_INPUT_MULTIPLE_FILES = 'multiple_files'
export const TYPE_INPUT_BOOLEAN = 'boolean'
export const TYPE_INPUT_DATE = 'date'
export const TYPE_INPUT_DATE_TIME = 'datetime'
export const TYPE_INPUT_TIME = 'time'
export const TYPE_INPUT_CALCULATED = 'calculated'
export const TYPE_INPUT_COUNTER = 'counter'
export const TYPE_INPUT_SIGNATURE = 'signature'
export const TYPE_CONSTANT_VALUE = 'constant_value'

export const STATUS_COMPLETED = 'completed'
export const STATUS_NOT_STARTED = 'not_started'
export const STATUS_IN_PROGRESS = 'in_progress'

export const LOCUS_GROUP_FIELD = 'locusGroup'
export const LOCUS_FIELD = 'locus'

export const REOPEN_ITEM = 'reopen'
export const COMPLETE_ITEM = 'complete'
export const PENDING = 'pending'
export const SEND_FOR_REVIEW = 'send-for-review'
export const SEND_BACK_FROM_REVIEW = 'send-back-from-review'
export const DELETE_ITEM = 'delete'
export const DUPLICATE_ITEM = 'duplicate'
export const DUPLICATE_ITEM_WITH_DATA = 'duplicateWithData'
export const REASSIGN_ITEM = 'reassign'
export const REASSIGN_SERIES = 'reassignSeries'
